module.exports = {"621222100":"城关镇","621222101":"碧口镇","621222102":"尚德镇","621222103":"中寨镇","621222104":"临江镇","621222105":"桥头镇","621222106":"梨坪镇","621222107":"天池镇","621222108":"堡子坝镇","621222109":"石坊镇","621222110":"石鸡坝镇","621222111":"丹堡镇","621222112":"中庙镇","621222113":"范坝镇","621222200":"铁楼藏族乡","621222205":"刘家坪乡","621222206":"玉垒乡","621222211":"口头坝乡","621222212":"尖山乡","621222215":"舍书乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621222.json
// module id = 3095
// module chunks = 0